import { __generator } from "tslib";
import { SeatingSequence } from '../interfaces';
var CHARS_IN_ALPHABET = 26;
export var isLowerCase = function (label) { return label.toLowerCase() === label; };
export var NumericLabel = function () { return ({
    labelToNumber: function (label) { return Number(label); },
    numberToLabel: function (num) { return num.toString(); },
}); };
export var AlphabeticLabel = function (lowerCase) {
    var charCodeA = lowerCase ? 'a'.charCodeAt(0) : 'A'.charCodeAt(0);
    var labelToNumber = function (label) {
        return label.split('').reduce(function (sum, char, charIndex) {
            var position = label.length - charIndex - 1;
            return sum + (char.charCodeAt(0) - charCodeA + 1) * Math.pow(CHARS_IN_ALPHABET, position);
        }, 0);
    };
    var numberToLabel = function (num) {
        var charPosition = (num - 1) % CHARS_IN_ALPHABET;
        var char = String.fromCharCode(charCodeA + charPosition);
        var next = Math.floor((num - 1) / CHARS_IN_ALPHABET);
        if (next > 0) {
            return numberToLabel(next) + char;
        }
        return char;
    };
    return {
        labelToNumber: labelToNumber,
        numberToLabel: numberToLabel,
    };
};
export var SeatLabelsGenerator = function (_a) {
    var _b, labelToNumber, numberToLabel, start, end, index, diff, max;
    var sequence = _a.sequence, startAt = _a.startAt, capacity = _a.capacity, _c = _a.reverseDirection, reverseDirection = _c === void 0 ? false : _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _b = sequence === SeatingSequence.NUMERIC ? NumericLabel() : AlphabeticLabel(isLowerCase(startAt)), labelToNumber = _b.labelToNumber, numberToLabel = _b.numberToLabel;
                start = labelToNumber(startAt);
                end = start + capacity;
                index = reverseDirection ? end - 1 : start;
                diff = reverseDirection ? -1 : 1;
                max = index + diff * capacity;
                _d.label = 1;
            case 1:
                if (!(index !== max)) return [3 /*break*/, 3];
                return [4 /*yield*/, numberToLabel(index)];
            case 2:
                _d.sent();
                index += diff;
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
//# sourceMappingURL=seat-labels-generator.js.map